export default "__VITE_ASSET__D96S4yto__"